/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { PropertyFeatures, getEnumTitle } from '@zcode/enums'

export const mapFeatures = (features: readonly PropertyFeatures[]) => {
  return features.map((featureId) => {
    return getEnumTitle(PropertyFeatures, featureId)
  })
}
